let supportedWebIntents = [];

const INTENT_PREFIXES = {
  tez: 'tez://upi/',
  gpay: 'tez://upi/',
  phonepe: 'phonepe://',
  paytm: `paytmmp://upi/`,
  generic: 'upi://',
};

const upiDeepLinkParams = (pgParams) => {
  const currency = pgParams['cu'];
  const reference = pgParams['tr'];
  const amount = pgParams['am'];
  const txnId = pgParams['tid'];
  const txnNote = pgParams['tn'];
  const merchantName = pgParams['pn'];
  const merchantVpa = pgParams['pa'];
  const merchantCode = pgParams['mc'];

  return `pay?pa=${merchantVpa}&pn=${merchantName}&tr=${reference}&tn=${txnNote}&am=${amount}&cu=${currency}&mc=${merchantCode}&tid=${txnId}`;
};


export const directIntentUrlForWeb = (paymentApp, pgParams) => {
  const prefix = INTENT_PREFIXES[paymentApp] || INTENT_PREFIXES.generic;
  const deepLinkURI = upiDeepLinkParams(pgParams);
  return `${prefix}${deepLinkURI}`;
};

const getSupportedMethod = (paymentApp) => {
  if (paymentApp === 'gpay') {
    return 'https://tez.google.com/pay';
  }
  if (paymentApp === 'phonepe') {
    return 'https://mercury.phonepe.com/transact/pay';
  }
};

export const checkPaymentAdapter = async (paymentApp) => {
  try {
    let pr = new PaymentRequest([
      {
        "supportedMethods": [
          getSupportedMethod(paymentApp)
        ]
      }
    ], {
      "total": {
        "label": "Payment",
        "amount": {
          "currency": "INR",
          "value": "1"
        }
      }
    });

    return await pr.canMakePayment();
  } catch (e) {
    return Promise.resolve(false);
  }
};

export const setSupportedWebIntents = (webIntents = []) => {
  supportedWebIntents = webIntents;
};

export const getSupportedWebIntents = () => supportedWebIntents;
